
import Button from '../base/Button';

export default function Header() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-100 fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/2fa60f0df8853b76462f672678c2d2c0/60646371fe59eeb3b2736bd305e004d6.png" 
              alt="PrecNacional Logo" 
              className="h-14 w-auto object-contain"
            />
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <a href="#inicio" className="text-gray-700 hover:text-blue-900 font-medium cursor-pointer transition-all duration-300 hover:scale-105 relative group">
              Início
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
            </a>
            <a href="#servicos" className="text-gray-700 hover:text-blue-900 font-medium cursor-pointer transition-all duration-300 hover:scale-105 relative group">
              Serviços
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
            </a>
            <a href="#processo" className="text-gray-700 hover:text-blue-900 font-medium cursor-pointer transition-all duration-300 hover:scale-105 relative group">
              Como Funciona
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
            </a>
            <a href="#sobre" className="text-gray-700 hover:text-blue-900 font-medium cursor-pointer transition-all duration-300 hover:scale-105 relative group">
              Sobre Nós
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
            </a>
            <a href="#contato" className="text-gray-700 hover:text-blue-900 font-medium cursor-pointer transition-all duration-300 hover:scale-105 relative group">
              Contato
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-900 transition-all duration-300 group-hover:w-full"></span>
            </a>
          </nav>
          
          <div className="flex items-center">
            <a
              href="https://wa.me/5531972176645?text=Olá! Gostaria de falar com vocês sobre precatórios."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white hover:bg-gray-50 text-green-600 border-2 border-green-600 font-semibold px-6 py-2 rounded-full transition-all duration-300 transform hover:scale-110 cursor-pointer whitespace-nowrap"
              style={{ animation: 'bounce 2s infinite' }}
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Fale Conosco
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
